/* @flow */
export const CONSENT_CHARGE_AMOUNT = '$0.50';
